<div class="modal active" *ngIf="errorLogsByCalcType">
    <div class="modal__container modal__container--lg">
      <div class="fields">
        <h2>Error Logs Display</h2>
        <div class="close" (click)="close()"><img src="/assets/img/close-white.svg" alt="" /></div>
        <div class="fields__container">
          <form autocomplete="off"  name="ErrorLogDisplayForm" #ngForm="ngForm" id="ErrorLogDisplayForm" class="active">
            <div class="fields__block">
              <div class="fields__block__section">
                <div class="table-fields">
                  <div style="max-height: 241px; overflow-y: scroll;">
                    <table>
                      <thead>
                        <tr>
                          <th scope="col">Calculation Type</th>
                          <th scope="col">Number Of Errors</th>
                          <th scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr mdbTableCol *ngFor="let errorLogEntry of errorLogsByCalcType | keyvalue">
                          <td>{{ getPrettyCalculationName(errorLogEntry.key) }}</td>
                          <td>{{ errorLogEntry.value.length }}</td>
                          <td>
                            <div class="btn">
                              <a (click)="downloadLogs(errorLogEntry.key)">Download</a>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="fields__btn">
              <button (click)="close()" type="submit" [ngClass]="'blue'" >
                Close
              </button>
              <button (click)="deleteAllErrorLogs()" type="submit" [ngClass]="'blue'" >
                Delete All Error Logs
              </button>
            </div>
          </form>
  
        </div>
      </div>
    </div>
</div>

